export default __webpack_public_path__ + "static/media/externalHardDrives.1b641593.svg";